import styled from 'styled-components'

import { buttonColorCSS } from './utils'
import { BaseButton } from '../BaseButton'

export const PositiveButtonStyled = styled(BaseButton)`
  ${(props) => {
    const button = props.theme.colors.button.positive

    return buttonColorCSS(button, {
      loader: {
        background: button.background.disabled,
        color: button.content.default,
      },
    })
  }}
`
